"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageErrorIndicator = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const icon_1 = __importDefault(require("./icon"));
const styled_div_1 = __importDefault(require("./styled-div"));
const theme_1 = __importDefault(require("../styles/theme"));
/**
 *
 * PageErrorIndicator Usage Example:
 *
 *  <Layout steps={[...steps]}>
 *    ...
 *    <PageErrorIndicator error="There was an error with the server." />
 *  </Layout>
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const ErrorLabel = styled_components_1.default.span `
  color: ${(props) => props.theme.colors.textDefault};
`;
const PageErrorIndicator = (_a) => {
    var { error } = _a, commonProps = __rest(_a, ["error"]);
    return (react_1.default.createElement(styled_div_1.default, Object.assign({}, commonProps, { flex: true, justifyContent: "center", alignItems: "center" }),
        react_1.default.createElement(styled_div_1.default, { flex: true, marginRight: "xs" },
            react_1.default.createElement(icon_1.default, { name: "error", color: theme_1.default.colors.error, size: "21px" })),
        react_1.default.createElement(ErrorLabel, null, error)));
};
exports.PageErrorIndicator = PageErrorIndicator;
exports.default = exports.PageErrorIndicator;
